import {CustomPreviewProps} from '@domain/kiln-monitoring'

const getDriveRepresentationComponents = (y: number, height: number) => {
  const rectPositions: number[] = []
  let position = y + 6
  const bottomY = y + height

  while (position < bottomY) {
    rectPositions.push(position)
    position += 12
  }

  return rectPositions
}

export const DriveSvg = ({x, y, width, height}: CustomPreviewProps) => {
  const rectPositions = getDriveRepresentationComponents(y, height)

  return (
    <>
      <g opacity="0.5">
        <g opacity="0.5" filter="url(#filter0_d_425_46561)">
          <g opacity="0.5" filter="url(#filter1_d_425_46561)">
            <rect
              x={x}
              y={y}
              width={width}
              height={height}
              rx="2"
              fill="url(#paint0_linear_425_46561)"
              fillOpacity="0.5"
              shapeRendering="crispEdges"
            />
            <rect
              x={x}
              y={y}
              width={width}
              height={height}
              rx="2"
              stroke="black"
              strokeOpacity="0.15"
              shapeRendering="crispEdges"
            />
          </g>
          <rect
            x={x}
            y={y}
            width={width}
            height={height}
            rx="2"
            fill="url(#paint1_linear_425_46561)"
            fillOpacity="0.5"
          />
          <rect
            x={x}
            y={y}
            width={width}
            height={height}
            rx="2"
            stroke="black"
            strokeOpacity="0.15"
          />
          <>
            {rectPositions.map((position) => (
              <rect
                key={position}
                x={x}
                y={position}
                width={width}
                height="6"
                fill="black"
                fillOpacity="0.1"
              />
            ))}
          </>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_425_46561"
          x={x}
          y={y}
          width={width}
          height={height}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_425_46561" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_425_46561"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_425_46561"
          x={x}
          y={y}
          width={width}
          height={height}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_425_46561"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_425_46561" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_425_46561"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_425_46561"
          x1={x}
          y1={y}
          x2={x + width}
          y2={y + height}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8D8C8C" />
          <stop offset="0.169027" stopColor="#CACACA" />
          <stop offset="0.497159" stopColor="white" />
          <stop offset="0.851333" stopColor="#CACACA" />
          <stop offset="1" stopColor="#8D8C8C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_425_46561"
          x1={x}
          y1={y}
          x2={x + width}
          y2={y + height}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8D8C8C" />
          <stop offset="0.169027" stopColor="#CACACA" />
          <stop offset="0.497159" stopColor="white" />
          <stop offset="0.851333" stopColor="#CACACA" />
          <stop offset="1" stopColor="#8D8C8C" />
        </linearGradient>
      </defs>
    </>
  )
}
